import type { RouteRecordRaw } from 'vue-router'

// Auth module route paths. Referenced via this constant so a path change is a
// single edit — never hard-code the string at call sites.
//
// The seller portal has a SINGLE entry point: `/login` hosts the one
// "Sign in with UAE PASS" screen (there is no separate sign-up screen — new
// sellers are auto-registered after the callback). `/login` is also where the
// router guard and the axios session-expiry redirect land, so it must exist.
export const authPaths = {
  LOGIN: '/login',
  UAE_PASS_CALLBACK: '/auth/uae-pass/callback',
} as const

// Pre-auth routes, mounted under the SignUpLayout shell.
//
// - LOGIN is guests-only (authenticated users are bounced to the dashboard by
//   the router guard).
// - UAE_PASS_CALLBACK is intentionally guard-less: it runs on return from UAE
//   Pass to resolve the outcome (login or new-seller sign-up) and must execute
//   regardless of the current auth state.
export const authRoutes: RouteRecordRaw[] = [
  {
    path: authPaths.LOGIN,
    name: 'LOGIN',
    component: () => import('./SignUpPage.vue'),
    meta: { requiresGuest: true },
  },
  {
    path: authPaths.UAE_PASS_CALLBACK,
    name: 'UAE_PASS_CALLBACK',
    component: () => import('./UaePassCallbackPage.vue'),
  },
]
